module.exports = "<a href=\"<%- url %>\" class=\"main-nav-link <%- customClasses %> <%- actionItemClass %>\"><%- title %></a>";